import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { base64Decoding, checkFormatAllow, clearSessionStorage } from "../../../common/util";
import ChangePwd from "./ChangePwd";
import { requests } from "common/RestAPI";
import { PAGE_URL, PLATFORM_URL } from "value/Url";
import { SESSIONSTORAGE } from "value/staticValues";


export default function ResetPwdContainer() {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");               // 입력한 비밀번호
    const [passwordCheck, setPasswordCheck] = useState("");     // 입력한 비밀번호 확인
    const [executeChangePasswordYn, setExecuteChangePasswordYn] = useState(false);

    const [infoText, setInfoText] = useState("");
    const [infoError, setInfoError] = useState(false);
    const [isCapsLockOn, setIsCapsLockOn] = useState(false);

    
    useEffect(() => {
        window.addEventListener("keyup", detectCapsLock);
        return () => {
            window.removeEventListener("keyup", detectCapsLock);
        };
    }, [])


    useEffect(() => {
        if(isCapsLockOn) {
            AlertFunction(t('CASPLOCK_ON_ALERT'), true);
        }
        else {
            AlertFunction("");
        }
    }, [isCapsLockOn])


    function detectCapsLock(e: KeyboardEvent) {
        if (e.getModifierState("CapsLock")) {
            setIsCapsLockOn(true);
        } else {
            setIsCapsLockOn(false);
        }
    }


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    function executeLogout() {
        const postData = {};
        requests
          .post(PLATFORM_URL.LOGOUT, postData)
          .then((response) => {
            setExecuteChangePasswordYn(false);
            clearSessionStorage();
            navigate(`${PAGE_URL.LOGIN}`);
          })
          .catch((error) => {
            setExecuteChangePasswordYn(false);
            clearSessionStorage();
            navigate(`${PAGE_URL.LOGIN}`);
          });
      }

    function sendChangePwdFn() {
        setExecuteChangePasswordYn(true);
        AlertFunction("", false);

        if(!checkFormatAllow(password, ["password"])) {
            AlertFunction(t("LOGIN_PASSWORD_INPUT_FORMAT_ERROR_MESSAGE"), true);
            return;
        } else if (password !== passwordCheck) {
            AlertFunction(t("PWD_NOT_MATCH_CHECK_ALERT_TEXT"), true);
            return;
        }

        const userId = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ID));
        
        const updatePackageData = {
            new_password:password
        };

        requests.put(PLATFORM_URL.USERS + `/${userId}` + PLATFORM_URL.PWD_CHANGE, updatePackageData)
        .then((response) => {
            if (response.status === 200 && response.data) {
                executeLogout();
            }
        })
        .catch((error)=>{
            executeLogout()
        })
    }

    return (
        <ChangePwd
            password={password}
            setPassword={setPassword}
            passwordCheck={passwordCheck}
            setPasswordCheck={setPasswordCheck}
            infoText={infoText}
            infoError={infoError}
            sendChangePwdFn={sendChangePwdFn}
            changePasswordYn={executeChangePasswordYn}
        />
    )
}